import { config } from '../config/config';

export type NotificationDto = {
  id: number;
  source: string;
  symbol: string;
  title: string;
  body: string;
  isRead: boolean;
  createdAtUtc: string;
  readAtUtc?: string | null;
};

const buildUrl = (path: string): string => {
  const base = config.backend.baseUrl;
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}`;
};

const authHeaders = (token: string) => ({
  Authorization: `Bearer ${token}`,
});

export const notificationsApi = {
  async list(token: string, take = 500): Promise<NotificationDto[]> {
    const url = buildUrl(`/notifications?take=${encodeURIComponent(String(take))}`);
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        ...authHeaders(token),
      },
    });

    if (!res.ok) {
      const text = await res.text().catch(() => '');
      throw new Error(`Failed to list notifications (${res.status}): ${text || res.statusText}`);
    }

    return res.json();
  },

  async markRead(token: string, id: number): Promise<void> {
    const url = buildUrl(`/notifications/${encodeURIComponent(String(id))}/read`);
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        ...authHeaders(token),
      },
    });

    if (!res.ok) {
      const text = await res.text().catch(() => '');
      throw new Error(`Failed to mark notification read (${res.status}): ${text || res.statusText}`);
    }
  },

  async markAllRead(token: string): Promise<void> {
    const url = buildUrl('/notifications/read-all');
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        ...authHeaders(token),
      },
    });

    if (!res.ok) {
      const text = await res.text().catch(() => '');
      throw new Error(`Failed to mark all notifications read (${res.status}): ${text || res.statusText}`);
    }
  },
};
